import { render, staticRenderFns } from "./news-list-item.vue?vue&type=template&id=5177ddaa&scoped=true"
import script from "./news-list-item.vue?vue&type=script&lang=js"
export * from "./news-list-item.vue?vue&type=script&lang=js"
import style0 from "./news-list-item.vue?vue&type=style&index=0&id=5177ddaa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5177ddaa",
  null
  
)

export default component.exports